import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48d5c963"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "indicator" }
const _hoisted_2 = { class: "indicator_graph" }
const _hoisted_3 = { class: "indicator_graph_denominator" }
const _hoisted_4 = { class: "indicator_label" }

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Indicator',
  props: {
  current: {
    type: Number,
    require: true,
  },
  max: {
    type: Number,
    require: true,
  },
},
  setup(__props) {

const props = __props



const calcProgressStyle = computed(() => {
  return `width: calc((100% / ${props.max}) * ${props.current})`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "indicator_graph_numerator",
          style: _normalizeStyle(_unref(calcProgressStyle))
        }, null, 4)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(__props.current) + "/" + _toDisplayString(__props.max), 1)
  ]))
}
}

})